<dx-popup [showTitle]="true" title="Proprietà {{tipologiaArticoli?.descrizione}}" [dragEnabled]="false" selectionMode="none" [hideOnOutsideClick]="false"
  [showCloseButton]="true" container=".dx-viewport" visible="true" (onHiding)="onEsciClick()">
  <div class="row">
    <div class="col-lg-4 col-md-6 col-sm-8 col-12 offset-lg-8 offset-md-6 offset-sm-4">
      <dx-button stylingMode="contained" text="SALVA" icon="save" type="success" (onClick)="onSalvaClick(false)" style="width: 100px; margin-right: 10px;">
      </dx-button>
      <dx-button stylingMode="contained" text="SALVA ED ESCI" icon="save" type="success" (onClick)="onSalvaClick(true)" style="width: 150px; margin-right: 10px;">
      </dx-button>
      <dx-button stylingMode="contained" text="ESCI" icon="close" type="danger" (onClick)="onEsciClick()" style="width: 100px;">
      </dx-button>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
      <dx-button stylingMode="contained" text="Aggiungi" icon="plus" type="normal" (onClick)="onAggiungiProprietaClick()" style="width: 150px; margin: 10px;">
      </dx-button>

    </div>
  </div>
  <dx-scroll-view width="100%" height="80%">
    <div class="row">
      @for (prop of props; track prop; let i = $index) {
        <div class="col-12 col-md-6 col-lg-4">
          <div class="card">
            <div class="card-header primary">
              {{prop.nome}}
              <span style="float: right!important;">
                <i class="dx-icon-clear" title="Rimuovi proprietà" (click)="onRemoveProprietaClick(prop)" style="cursor: pointer;color:#d9534f;"></i>
              </span>
            </div>
            <div class="card-body">
              <div class="dx-field">
                <div class="dx-field-label"><b>Nome</b></div>
                <div class="dx-field-value">
                  <dx-text-box
                    [(value)]="prop.nome">
                  </dx-text-box>
                </div>
              </div>
              <div class="dx-field">
                <div class="dx-field-label"><b>Obbligatorio</b></div>
                <div class="dx-field-value">
                  <dx-check-box [(value)]="prop.obbligatorio">
                  </dx-check-box>
                </div>
              </div>
              <div class="dx-field">
                <div class="dx-field-label"><b>Tipo</b></div>
                <div class="dx-field-value">
                  <dx-lookup
                    valueExpr="id"
                    [dataSource]="listTipiProps"
                    [searchEnabled]="true"
                    [(value)]="prop.tipo"
                    displayExpr="descrizione">
                  </dx-lookup>
                </div>
              </div>
              @if (prop.tipo == TIPO_PROPRIETA_ARTICOLO_DATA) {
                <div class="dx-field">
                  <div class="dx-field-label"><b>Notifica attiva</b></div>
                  <div class="dx-field-value">
                    <dx-check-box [(value)]="prop.controlloNotifica.attivo">
                    </dx-check-box>
                  </div>
                </div>
              }
              @if (prop.tipo == TIPO_PROPRIETA_ARTICOLO_DATA && prop.controlloNotifica?.attivo) {
                <div class="dx-field">
                  <div class="dx-field-label"><b>Giorni pre</b></div>
                  <div class="dx-field-value">
                    <dx-number-box
                      [(value)]="prop.controlloNotifica.giorniPreAlert"
                      [showSpinButtons]="true"
                      step="1">
                    </dx-number-box>
                  </div>
                </div>
              }
              @if (prop.tipo == TIPO_PROPRIETA_ARTICOLO_SELMULTI) {
                <div class="dx-field">
                  <div class="dx-field-label"><b>Elenco</b></div>
                  <div class="dx-field-value">
                    <div class="row">
                      <div class="col-10">
                        <dx-text-box
                          [(value)]="newValueMultiTracker[i]">
                        </dx-text-box>
                      </div>
                      <div class="col-2">
                        <i class="dx-icon-plus" title="Aggiungi valore" (click)="onAddValueMulti(prop, i)" style="cursor: pointer;color:#0056b3; position: absolute; top: 50%; -ms-transform: translateY(-50%); transform: translateY(-50%);"></i>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12" style="display: flex; flex-wrap: wrap;">
                        @for (val of prop.selMultiplaDati; track val) {
                          <div style="padding: 3px; margin-right: 2px; margin-top: 2px; border-style: solid;border-width: 0.1em;border-color: #0056b3;border-radius: 0.5em;">
                            <span style="position:relative; padding-left:3px; padding-right: 15px;">{{val}} <i class="dx-icon-clear" title="Rimuovi valore" (click)="onRemoveValoreMulti(val, prop)" style="margin-left:1px; cursor: pointer;color:#d9534f; position: absolute; top: 50%; -ms-transform: translateY(-50%); transform: translateY(-50%);"></i></span>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </dx-scroll-view>
</dx-popup>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)"
  [(visible)]="loadPanelVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false">
</dx-load-panel>